import { render, staticRenderFns } from "./CardPaginatedTable.vue?vue&type=template&id=54ac074e&"
import script from "./CardPaginatedTable.vue?vue&type=script&lang=js&"
export * from "./CardPaginatedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports